function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import React, { useId } from "react";
import * as select from "@zag-js/select";
import { useMachine, normalizeProps, Portal } from "@zag-js/react";
import { useAccentColors } from "../../hooks";
import { changeColorVariableWeight, waitForClick } from "../../utils";
import { ChevronDown } from "../../visuals";
export default function FilterDropdown(param) {
    var value = param.value, options = param.options, _param_accentColor = param.accentColor, accentColor = _param_accentColor === void 0 ? "--colors-purple-700" : _param_accentColor, className = param.className, onChange = param.onChange;
    var hoverAccentColor = accentColor.startsWith("--colors-") ? changeColorVariableWeight(accentColor, function(v) {
        return v + 200;
    }) : accentColor;
    var accentStyle = useAccentColors([
        "colors-button-ghost-fg-hover",
        accentColor
    ], [
        "colors-button-main-bg-base",
        accentColor
    ], [
        "colors-button-main-bg-hover",
        hoverAccentColor
    ]);
    var collection = select.collection({
        items: options,
        itemToString: function(item) {
            return item.label;
        },
        itemToValue: function(item) {
            return item.value;
        }
    });
    var _useMachine = _sliced_to_array(useMachine(select.machine({
        id: useId(),
        collection: collection,
        multiple: false,
        value: value ? [
            value
        ] : [],
        positioning: {
            sameWidth: true
        },
        onValueChange: function onValueChange(details) {
            var _details_value;
            var _details_value_;
            onChange === null || onChange === void 0 ? void 0 : onChange((_details_value_ = (_details_value = details.value) === null || _details_value === void 0 ? void 0 : _details_value[0]) !== null && _details_value_ !== void 0 ? _details_value_ : null);
        }
    })), 2), state = _useMachine[0], send = _useMachine[1];
    var api = select.connect(state, send, normalizeProps);
    var _api_valueAsString;
    return /*#__PURE__*/ React.createElement("div", _object_spread({
        className: className,
        style: accentStyle
    }, api.rootProps), /*#__PURE__*/ React.createElement("div", api.controlProps, /*#__PURE__*/ React.createElement("button", _object_spread_props(_object_spread({
        type: "button"
    }, api.triggerProps), {
        className: "flex justify-center items-center text-button-base font-bold font-heading p-4 w-full rounded-full bg-button-main-bg-base text-button-main-fg-base hover:bg-button-main-bg-hover"
    }), /*#__PURE__*/ React.createElement("span", null, (_api_valueAsString = api.valueAsString) !== null && _api_valueAsString !== void 0 ? _api_valueAsString : "Select option"), /*#__PURE__*/ React.createElement("span", {
        className: "ml-2"
    }, /*#__PURE__*/ React.createElement(ChevronDown, {
        className: "block"
    })))), /*#__PURE__*/ React.createElement(Portal, null, /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({}, api.positionerProps), {
        style: _object_spread({}, accentStyle, api.positionerProps.style),
        className: "z-50 md:hidden"
    }), /*#__PURE__*/ React.createElement("ul", _object_spread_props(_object_spread({}, api.contentProps), {
        className: "py-5 bg-button-main-bg-base text-button-main-fg-base rounded-xl"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max"
    }, options.map(function(item) {
        return /*#__PURE__*/ React.createElement("li", _object_spread_props(_object_spread({
            key: item.value
        }, api.getItemProps({
            item: item
        })), {
            onPointerUp: function() {
                var _ref = _async_to_generator(function(event) {
                    var _itemProps_onPointerUp, itemProps;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // wait for onclick to resolve -> otherwise the Dropdown will close before click events which can cause "ghost" click events on elements below
                                return [
                                    4,
                                    waitForClick(event)
                                ];
                            case 1:
                                _state.sent();
                                itemProps = api.getItemProps({
                                    item: item
                                });
                                (_itemProps_onPointerUp = itemProps.onPointerUp) === null || _itemProps_onPointerUp === void 0 ? void 0 : _itemProps_onPointerUp.call(itemProps, event);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(event) {
                    return _ref.apply(this, arguments);
                };
            }(),
            className: "cursor-pointer px-6 py-2 [&[data-state=checked]]:bg-button-main-bg-hover [&[data-state=checked]]:font-bold [&[data-highlighted]]:font-bold"
        }), /*#__PURE__*/ React.createElement("span", null, item.label));
    }))))));
}

//# sourceMappingURL=FilterDropdown.js.map